import { render, staticRenderFns } from "./template-work-order-edit-form.html?vue&type=template&id=72e94c29&scoped=true&"
import script from "./template-work-order-edit-form.js?vue&type=script&lang=js&"
export * from "./template-work-order-edit-form.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e94c29",
  null
  
)

export default component.exports